module.exports = __webpack_public_path__ + "media/images/story/icon/heart-79b20bc648342685bf62bffb51fd08f8.svg";